module.exports = __webpack_public_path__ + "static/img/exportTaxRebate.394ab0a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tryout/exportTaxRebate.png
// module id = 7DSZ
// module chunks = 34